module.exports = {"TXTCLI_Join_a_club":{"id":"TXTCLI_Join_a_club","defaultMessage":"Вступить в клуб","track":"Join a club"}}